/**
 * KAN-943: главная приложения на маршруте "/m". Адрес "/m" без слеша
 * заменяется на "/m/" (replace, search и hash сохраняются): scope манифеста
 * PWA "/m/", иначе Chrome не предлагает установку. На "/m/" рендерит главную.
 */
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { mobileSlashRedirect } from '@/lib/mobileApp';

interface MobileSlashRedirectProps {
  children: ReactNode;
}

export function MobileSlashRedirect({ children }: MobileSlashRedirectProps) {
  const { pathname, search, hash } = useLocation();
  const target = mobileSlashRedirect(pathname, search, hash);
  if (target !== null) return <Navigate to={target} replace />;
  return <>{children}</>;
}
